import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducer";

// Load dark mode from localStorage
const savedDarkMode = localStorage.getItem("darkMode") === "true";
const savedTranslation = localStorage.getItem("translation");

function getBrowserTranslationDefault() {
  const browserLanguages =
    typeof navigator !== "undefined"
      ? navigator.languages || [navigator.language]
      : [];

  const isSpanishLocale = browserLanguages.some((language) =>
    language?.toLowerCase().startsWith("es"),
  );

  return !isSpanishLocale;
}

const initialTranslation =
  savedTranslation === null
    ? getBrowserTranslationDefault()
    : savedTranslation === "true";

const preloadedState = {
  translation: initialTranslation,
  darkMode: savedDarkMode,
};

const store = createStore(reducer, preloadedState, applyMiddleware(thunk));

store.subscribe(() => {
  localStorage.setItem("translation", store.getState().translation.toString());
});

export default store;
